import constants from 'constants';

const {
  CREATE_USER_SAGA,
  LOAD_CURRENT_USER_SAGA,
  UPDATE_URL_USER_SAGA,
  UPDATE_USER,
  UPDATE_USER_SAGA,
  CONFIRM_EMAIL_SAGA,
  ADD_ADMIN_USERS,
  LOAD_ADMIN_USERS_SAGA,
  ADMIN_CREATE_USER_SAGA,
  ADMIN_CREATE_USER_SPONSOR_SAGA,
  ADMIN_DELETE_USERS_SAGA,
  LOAD_EDIT_USER_SAGA,
  SET_EDIT_USER,
  ADMIN_UPDATE_USER_SAGA,
  USER_FILTER_SAGA,
  USER_SPONSOR_FILTER_SAGA,
  LOAD_ADMIN_DASHBOARD_USERS_SAGA,
  ADD_ADMIN_DASHBOARD_USERS,
  SET_PROFILE_CONFIRMATION
} = constants;

export const createUser = (user) => ({
  type: CREATE_USER_SAGA,
  user
})

export const updateUserSaga = (user) => ({
  type: UPDATE_USER_SAGA,
  user
})

export const loadCurrentUser = () => ({
  type: LOAD_CURRENT_USER_SAGA
})

export const updateUrlUser = (data) => ({
  type: UPDATE_URL_USER_SAGA,
  data
})

export const updateUser = (user, session) => ({
  type: UPDATE_USER,
  payload: { user },
  session
})

export const confirmUserEmailSaga = (token) => ({
  type: CONFIRM_EMAIL_SAGA,
  token
})

export const addAdminUsers = (values, count, page, total_pages, query = {}) => ({
  type: ADD_ADMIN_USERS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const loadAdminUsersSaga = (page) => ({
  type: LOAD_ADMIN_USERS_SAGA,
  page
})

export const adminCreateUserSaga = (user) => ({
  type: ADMIN_CREATE_USER_SAGA,
  user
})

export const adminCreateUserSponsorSaga = (user) => ({
  type: ADMIN_CREATE_USER_SPONSOR_SAGA,
  user
})

export const adminUpdateUserSaga = (user) => ({
  type: ADMIN_UPDATE_USER_SAGA,
  user
})

export const adminDeleteUserSaga = (user_ids) => ({
  type: ADMIN_DELETE_USERS_SAGA,
  user_ids
})

export const loadEditUser = (user_id) => ({
  type:   LOAD_EDIT_USER_SAGA,
  user_id
})

export const setEditUser = (user) => ({
  type:   SET_EDIT_USER,
  payload: {
    user
  }
})

export const adminUserFilter = (query, page = 1, per_page = 400) => ({
  type:   USER_FILTER_SAGA,
  query,
  page,
  per_page
})

export const adminUserSponsorFilter = (query, page = 1) => ({
  type:   USER_SPONSOR_FILTER_SAGA,
  query,
  page
})

export const loadAdminAdminDashboardUsersSaga = (query) => ({
  type:   LOAD_ADMIN_DASHBOARD_USERS_SAGA,
  query
})

export const addAdminAdminDashboardUsers = (statistics) => ({
  type:   ADD_ADMIN_DASHBOARD_USERS,
  payload: {
    statistics
  }
})

export const setProfileConfirmation = (value) => ({
  type: SET_PROFILE_CONFIRMATION,
  payload: {
    showProfileConfirmation: value
  }
})



/** WEBPACK FOOTER **
 ** ./src/actions/users.js
 **/